import { BRAND_DERIVED_LABELS, GENRE_MAPPINGS, NETWORK_LABELS, SPECIAL_LABEL, ATTENTION_INDEX_STREAMING_LABELS } from '../constants/labels'
import * as TLM from '../constants/tlm'
import { PLACEHOLDER_IMG, LIFESTYLE_PLACEHOLDER, MEDIA_PLANNING_ROLL_OVER_MONTHS, MEDIA_PLANNING_TOTAL_MONTHS, MEDIA_PLANNING_CALENDAR_CHANNEL_INDEX, MEDIA_PLANNING_CALENDAR_CURRENT_YEAR_INDEX, MEDIA_PLANNING_MONTHS_START_INDEX } from '../constants/commons'
import moment from 'moment'
import DateHelpers from './../classes/DateHelpers'

/* Collection of helpers for dealing with Topics */
class TopicHelpers {
  topicTypeFromDetails (details) {
    if (details.is_entity) {
      return 'Entity'
    }
    return TLM.VIDEO
  }

  topicSubTypeFromDetails (details) {
    if (details.is_entity) {
      return details.entity_type
    } else if (details.is_video_channel) {
      return TLM.CHANNEL
    } else if (details.is_video) {
      return TLM.VIDEO
    }
    return null
  }

  static DefaultSubTypeImageOptions = {
    root: '',
    suffix: ''
  }

  getBrandDerivedLabels (labels) {
    if (labels && labels.length > 0) {
      const allLabels = BRAND_DERIVED_LABELS.split(',')
      for (let label of labels) {
        for (let lbl of allLabels) {
          if (label === lbl) {
            return label
          }
        }
      }
    }
    return null
  }

  getCategory (topic) {
    if (topic.entity_type === TLM.SHOW && topic.genres) {
      return topic.genres[0]
    }
    else if (topic.entity_type === TLM.BRAND && topic.labels) {
      return this.getBrandDerivedLabels(topic.labels)
    }
  }

  getNetworkLabel (labels) {
    if (labels && labels.length > 0) {
      const allLabels = (NETWORK_LABELS + ',' + ATTENTION_INDEX_STREAMING_LABELS).split(',')
      for (let label of labels) {
        for (let lbl of allLabels) {
          if (label === lbl) {
            return label
          }
        }
      }
    }
    return null
  }

  getGenreLabel (labels) {
    if (labels && labels.length > 0) {
      const allLabels = (GENRE_MAPPINGS + ',' + SPECIAL_LABEL).split(',')
      for (let label of labels) {
        for (let lbl of allLabels) {
          if (label === lbl) {
            return label
          }
        }
      }
    }
    return null
  }

  equals (value1, value2) {
    return JSON.stringify(value1) === JSON.stringify(value2)
  }
  thumbnail (r) {
    if (r.entity_localization_override && r.entity_localization_override.length > 0 && r.entity_localization_override[0].entity_override_image) {
      return r.entity_localization_override[0].entity_override_image
    }
    if (r.entity_override_image) {
      return r.entity_override_image
    }
    if (r.thumbnail) {
      return r.thumbnail
    } else if (r.entity_type === 'Lifestyle') {
      return LIFESTYLE_PLACEHOLDER
    }
    return PLACEHOLDER_IMG
  }

  mediaPlanningCalendarHeader () {
    const currentMonth = new Date().getMonth()
    const currentYear = new Date().getFullYear()
    const nextYear = currentYear + 1
    const monthNames = moment.months()
    const shortMonthNames = monthNames.map(month => moment().month(month).format('MMM'));
    const nextSixMonths = Array.from({length: MEDIA_PLANNING_ROLL_OVER_MONTHS}, (_, i) => shortMonthNames[(currentMonth + i) % MEDIA_PLANNING_TOTAL_MONTHS])
    nextSixMonths.unshift('')
    nextSixMonths.push(currentYear, nextYear)
    return nextSixMonths
  }

  mediaPlanningCalendarBody () {
    const calendarHeader = this.mediaPlanningCalendarHeader()
    const calendarBody = calendarHeader.map((item, index) => {
      if (index === MEDIA_PLANNING_CALENDAR_CHANNEL_INDEX) {
        return { value: 'channel', affinity: '' }
      } else if (index >= MEDIA_PLANNING_MONTHS_START_INDEX && index <= MEDIA_PLANNING_ROLL_OVER_MONTHS) {
        return { value: item.toLowerCase(), affinity: `${item.toLowerCase()}Affinity` }
      } else if (index === MEDIA_PLANNING_CALENDAR_CURRENT_YEAR_INDEX) {
        return { value: 'currentYear', affinity: 'currentYearAffinity' }
      } else {
        return { value: 'nextYear', affinity: 'nextYearAffinity' }
      }
    })
    return calendarBody
  }

reformatRecommendations (recommendations) {
  const recos = recommendations && recommendations.length && recommendations.map((recommendation, index) => {
    const r = recommendation.recommendation
    return {
      row_id: recommendation.rank_index ? recommendation.rank_index: index+1,
      topic_id: r.id,
      topic_type: this.topicTypeFromDetails(r),
      topic_subtype: this.topicSubTypeFromDetails(r),
      topic_name: r.is_video ? r.title : r.display_name || r.name,
      topic_search_name: r.is_video ? r.title : r.name,
      thumbnail: this.thumbnail(r),
      channel_name: r.channel_name,
      platform_assigned_id: r.platform_assigned_id,
      score: recommendation.score,
      labels: r.labels ? ',' + r.labels.join(',') + ',' : null,
      published_date: r.published_at,
      active_date: r.entity_localization_override && r.entity_localization_override.length > 0 && r.entity_localization_override[0].active_date ? r.entity_localization_override[0].active_date : r.active_date,
      networkLabel: this.topicSubTypeFromDetails(r) === TLM.SHOW ? this.getNetworkLabel(r.labels) : null,
      category: this.topicSubTypeFromDetails(r) === TLM.SHOW || this.topicSubTypeFromDetails(r) === TLM.MOVIE ? this.getNetworkLabel(r.labels) : this.topicSubTypeFromDetails(r) === TLM.BRAND ? this.getBrandDerivedLabels(r.labels) : null,
      entity_localization_override: r.entity_localization_override,
      genre: this.getGenreLabel(r.labels)
    }
  })
  return recos
}

calendarFormatter (recommendation) {
  const calendarObj =[]
  const currentYear = new Date().getFullYear()
  const currentMonthInNum = moment(new Date()).format('MM')
  const nextYear = currentYear + 1
  let obj = {}
  let date
  let month
  let monthInNum
  let year
  const monthArr = this.mediaPlanningCalendarHeader()
  const calendarArr = monthArr.map(str => typeof str === 'string' ? str.toLowerCase() : str)
  recommendation && recommendation.length && recommendation.forEach(e => {
    obj = {}
    date = e.entity_localization_override && e.entity_localization_override.length > 0 && e.entity_localization_override[0].active_date ? e.entity_localization_override[0].active_date : e.active_date
    year = new Date(date).getFullYear()
    month = moment(date).format('MMM').toLowerCase()
    monthInNum = moment(date).format('MM')
    obj['channel'] = e.category || e.networkLabel
    //the following will create a key for entites present with same premiere month with the respective month names
    calendarArr.map((val, key) => {
      if (key >= MEDIA_PLANNING_MONTHS_START_INDEX && key <= MEDIA_PLANNING_ROLL_OVER_MONTHS) {
        // checking current month greater than June currentMonthInNum > 6, to check condition for months of next year
        obj[val] = (month === val && ((currentMonthInNum <= monthInNum && year == currentYear) || (currentMonthInNum > monthInNum && year == nextYear))) ? 1 : 0
        obj[`${val}Affinity`] = (month === val && ((currentMonthInNum <= monthInNum && year == currentYear) || (currentMonthInNum > monthInNum && year == nextYear))) ? e.score : 0

        // DWA-3169 logic
        if (val === 'dec' && month == val && year == currentYear && DateHelpers.isYearEndDate(moment(DateHelpers.getDateWithoutTime(date))) && !DateHelpers.isCurrentMonthPastOctober()) {
          obj[val] = 0
          obj[`${val}Affinity`] = 0
        }
      }
    })
    //the following will create a key for entites based on the premiere date to currernt year or next year
    obj['currentYear'] = moment(date).year() === currentYear ? 1 : 0
    obj['nextYear'] = moment(date).year() === nextYear ? 1 : 0
    obj['score'] = e.score//affinity of a network for arrranging in ascending
    obj['currentYearAffinity'] = new Date(date).getFullYear() === currentYear ? e.score : 0
    obj['nextYearAffinity'] = moment(date).year() === nextYear ? e.score : 0
    calendarObj.push(obj)
  })
  const uniqueObj = calendarObj.reduce((acc, curr) => {
    const found = acc.find(item => item.channel === curr.channel)
      if (found) {
        found.currentYear += curr.currentYear
        calendarArr.map((val, key) => {
          if (key >= MEDIA_PLANNING_MONTHS_START_INDEX && key <= MEDIA_PLANNING_ROLL_OVER_MONTHS) {
            found[val] += curr[val]
            found[`${val}Affinity`] += curr[`${val}Affinity`]
          }
        })
        found.nextYear += curr.nextYear
        found.score += curr.score//sum of affininty of all entities of a network for ascending
        found.currentYearAffinity += curr.currentYearAffinity
        found.nextYearAffinity += curr.nextYearAffinity
      } else {
        acc.push(curr)
      }
    return acc
  }, [])
    let stabilizedCalendarObj = uniqueObj.filter(e => e.channel !== null && e.channel !== 'HBO' && e.channel !== 'HBO Max')
    let equalChannel = uniqueObj.filter(e => e.channel === 'HBO' || e.channel === 'HBO Max')
    const mergedChannel = equalChannel.reduce((acc, item) => {
      Object.keys(item).forEach((key) => {
        if (key === 'channel') {
          acc[key] = acc[key] ? `${acc[key]}/${item[key]}` : item[key];
        } else {
          acc[key] = (typeof(acc[key]) === 'number' && typeof(item[key]) === 'number') ? acc[key] + item[key] : acc[key] || item[key]
        }
      })
      return acc;
    }, {})
    stabilizedCalendarObj.push(mergedChannel)
    stabilizedCalendarObj.sort((a, b) => {
      return b.score - a.score
    })
    return stabilizedCalendarObj
}
}
const instance = new TopicHelpers()

export default instance
